import * as React from "react";
const SvgTwoVerticalLine = props => <svg width="1em" height="1em" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.25 16V2h.875v14H5.25Zm3.5 0h-.875V2h.875v14Z" /></svg>;
export default SvgTwoVerticalLine;